import axios from 'axios';

export const modulePit = {
	state() {
		return {
			pitStatement: null,
			pitFiles: [],
		};
	},
	mutations: {
		setPitStatement(state, data) {
			state.pitStatement = data;
		},
		addPitFile(state, data) {
			state.pitFiles.push(data);
		},
		clearPitFiles(state) {
			state.pitFiles = [];
		},
	},
	getters: {
		getPitStatement: (state) => state.pitStatement,
		getPitFiles: (state) => state.pitFiles,
	},
	actions: {
		fetchPitStatement({ commit, dispatch }) {
			commit('setPitLoader', true);

			dispatch('newLogoutTime');
			axios
				.get('api/Pit')
				.then((response) => {
					commit('clearPitFiles');
					commit('setPitStatement', response.data);
					if (response.data.files !== null) {
						response.data.files.forEach((file) => {
							dispatch('fetchFiles', file);
						});
					}
					commit('setPitLoader', false);
				})

				.catch(() => {
					commit('setPitLoader', false);
				});
		},
		postAcceptDeclaration({ dispatch, commit }) {
			commit('setPitLoader', true);
			dispatch('newLogoutTime');
			axios
				.post('api/pit/Accept', null)
				.then(() => {
					dispatch('fetchPitStatement');
					window.scroll({
						top: 0,
						left: 0,
						behavior: 'smooth',
					});
					commit('setPitLoader', false);
				})
				.catch(() => {
					commit('setPitLoader', false);
				});
		},
		postCancelDeclaration({ dispatch }) {
			dispatch('newLogoutTime');
			axios
				.post('api/pit/CancelAccept', null)
				.then(() => {
					dispatch('fetchPitStatement');
				})
				.catch(() => {});
		},
		fetchFiles({ commit, dispatch }, file) {
			commit('setPitLoader', true);

			dispatch('newLogoutTime');
			axios
				.get(
					'api/Pit/GetFile/' +
						file.directory +
						'/' +
						file.fileName +
						'',
					{
						responseType: 'blob',
					}
				)
				.then((response) => {
					commit('setPitLoader', false);
					commit('addPitFile', {
						url: window.URL.createObjectURL(response.data),
						fileName: file.fileName,
					});
				})
				.catch(() => {
					commit('setPitLoader', false);
				});
		},
	},
};
